import { render, staticRenderFns } from "./referansagore.vue?vue&type=template&id=0aef7db6&scoped=true"
import script from "./referansagore.vue?vue&type=script&lang=js"
export * from "./referansagore.vue?vue&type=script&lang=js"
import style0 from "./referansagore.vue?vue&type=style&index=0&id=0aef7db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef7db6",
  null
  
)

export default component.exports